module.exports = __webpack_public_path__ + "static/media/gd.3c05bb49.svg";